/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nav_open_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open menu`)
};

const es_nav_open_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir menú`)
};

const de_nav_open_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü öffnen`)
};

const nl_nav_open_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu openen`)
};

const fr_nav_open_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le menu`)
};

const it_nav_open_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri menu`)
};

const pt_br2_nav_open_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir menu`)
};

const pt_nav_open_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir menu`)
};

const ja_nav_open_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニューを開く`)
};

const zh_nav_open_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开菜单`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nav_open_menu = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nav_open_menu(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nav_open_menu", locale)
	if (locale === "en") return en_nav_open_menu(inputs)
	if (locale === "es") return es_nav_open_menu(inputs)
	if (locale === "de") return de_nav_open_menu(inputs)
	if (locale === "nl") return nl_nav_open_menu(inputs)
	if (locale === "fr") return fr_nav_open_menu(inputs)
	if (locale === "it") return it_nav_open_menu(inputs)
	if (locale === "pt-BR") return pt_br2_nav_open_menu(inputs)
	if (locale === "pt") return pt_nav_open_menu(inputs)
	if (locale === "ja") return ja_nav_open_menu(inputs)
	return zh_nav_open_menu(inputs)
};